import PropTypes from 'prop-types';

export const webAndMobileRootPropTypes = {
  planCycleType: PropTypes.string,
  setPlanCycleType: PropTypes.func,
  activePlanId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  activePlanName: PropTypes.string,
  addons: PropTypes.array,
  staticIpPlans: PropTypes.array,
  userStaticIp: PropTypes.shape({
    has_static_ip: PropTypes.bool,
    ip_address: PropTypes.string,
    active_till: PropTypes.string,
    assigned_at: PropTypes.string,
    is_expired: PropTypes.bool,
    plan_name: PropTypes.string,
  }),
  couponCode: PropTypes.string,
  setCouponCode: PropTypes.func,
  isApplied: PropTypes.bool,
  appliedCouponConfig: PropTypes.object,
  creditBalance: PropTypes.number,
  setCreditBalance: PropTypes.func,
  isCreditApplied: PropTypes.bool,
  setIsCreditApplied: PropTypes.func,
  message: PropTypes.string,
  currentCyclicPeriodPlans: PropTypes.array,
  plansGroupedByCyclicMonths: PropTypes.object,
  shouldShowAddons: PropTypes.bool,
  isSubscriptionActive: PropTypes.bool,
  onCouponUpdate: PropTypes.func
};

export const webAndMobileDefaultProps = {
  planCycleType: 'monthly',
  setPlanCycleType: () => { },
  activePlanId: null,
  activePlanName: '',
  addons: [],
  staticIpPlans: [],
  userStaticIp: null,
  couponCode: '',
  setCouponCode: () => { },
  isApplied: false,
  appliedCouponConfig: {},
  creditBalance: 0,
  setCreditBalance: () => { },
  isCreditApplied: false,
  setIsCreditApplied: () => { },
  message: '',
  currentCyclicPeriodPlans: [],
  plansGroupedByCyclicMonths: {},
  shouldShowAddons: false,
  isSubscriptionActive: false,
  onCouponUpdate: () => { }
};
